import React from "react";
import { Field, reset, reduxForm } from "redux-form";

let CreateTodo = (props) => {
  const { handleSubmit } = props;
  return (
    <form className="form form--horizontal" onSubmit={handleSubmit}>
      <Field name="title" component="input" type="text" />
    </form>
  );
};

export default reduxForm({
  form: "create_user_todo", // a unique identifier for this form
  onSubmitSuccess: (result, dispatch) => dispatch(reset("create_user_todo")),
})(CreateTodo);
